import React from 'react';
import PropTypes from 'prop-types';
import { Cookies } from 'react-cookie';
import { Dialog, IconButton, Paper, Subheader } from 'material-ui';
import { white } from 'material-ui/styles/colors';
import ActionFavorite from 'material-ui/svg-icons/action/favorite';
import { ActionVisibility, ActionVisibilityOff } from 'material-ui/svg-icons';
import styles from './PointInfo.css';
import style from '../../../styles/styles';
import Info from '../../common/Info/Info';
import withTranslation from '../../../hoc/withTranslation';
import ModuleService from '../../../services/module';
import QRCodeIcon from '../../icon/QRCodeIcon';
import APIService from '../../../services/api'
import { RICHTEXT } from '../../../constants/customfiled';

const cookies = new Cookies();
const Timestamp = require('react-timestamp');

class PointInfo extends React.Component {
    static propTypes = {
        point: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        lang: PropTypes.string,
        customFields: PropTypes.arrayOf(PropTypes.object),
        disabledHeaderIcons: PropTypes.bool
    };

    state = {
        img: null
    };

    static defaultProps = {
        customFields: [],
        lang: 'fr',
        disabledHeaderIcons: false,
    };

    onClose = () => {
        this.setState({ img: null });
    }

    getQrCode = async() => {
        const img = await APIService.getDynamicLinkQrCode(this.props.app.id, 'points', this.props.point.id, 'png', cookies.get('token'), this.props.lang);
        this.setState({ img: window.webkitURL.createObjectURL(img) });
    }

    render() {
        const point = this.props.point;
        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('generic.information')}
                    {!this.props.disabledHeaderIcons
                    && ModuleService.hasModule(this.props.app, ModuleService.DYNAMIC_LINK)
                    && <IconButton
                        style={styles.qrCodeIcon}
                        tooltipPosition='bottom-left'
                        onClick={this.getQrCode}
                    >
                        <QRCodeIcon color={white} />
                    </IconButton>
                    }
                    {!this.props.disabledHeaderIcons
                    && point.is_favorite &&
                    <IconButton
                        style={styles.rightIcon}
                        tooltip={this.props.t('module.open_explore.favorite_point')}
                        tooltipPosition='bottom-left'
                    >
                        <ActionFavorite color={white} />
                    </IconButton>
                    }
                    {!this.props.disabledHeaderIcons
                    &&<IconButton
                        style={styles.rightVisibleIcon}
                        tooltip={this.props.t(point.visible
                            ? 'module.open_explore.visible_point'
                            : 'module.open_explore.not_visible_point')}
                        tooltipPosition='bottom-left'
                    >
                        {point.visible && <ActionVisibility color={white} />}
                        {!point.visible && <ActionVisibilityOff color={white} />}
                    </IconButton>}
                </Subheader>

                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={point.id}
                    />
                    {point.latitude && point.longitude &&
                    <Info
                        title={this.props.t('generic.coordinates')}
                        content={`${point.latitude}, ${point.longitude}`}
                    />
                    }
                    {point.name &&
                    <Info
                        title={this.props.t('generic.name')}
                        content={point.name}
                    />
                    }
                    {point.description &&
                    <Info
                        title={this.props.t('generic.description')}
                        content={point.description}
                        html={true}
                    />
                    }
                    {point.tag &&
                    <Info
                        title={this.props.t('generic.tag')}
                        content={point.tag}
                    />
                    }
                    {point.custom_fields &&
                    point.custom_fields.filter(cf => cf.value != null).map((cf) => {
                        let customField = this.props.customFields.find(item => item.id === cf.id);
                        let name = cf.id;

                        if (customField) {
                            name = customField.name;
                        }

                        if (cf.tag && cf.tag.length > 0) {
                            name += ' (' + cf.tag + ')';
                        }
                        return (
                            <Info
                                key={cf.id}
                                title={name}
                                content={cf.value}
                                html={customField.type === RICHTEXT}
                            />
                        );

                    })}
                    <Info
                        title={this.props.t('generic.created_at')}
                        content={<Timestamp time={this.props.point.created_at} format='full'
                                            twentyFourHour />}
                    />
                    <Info
                        title={this.props.t('generic.updated_at')}
                        content={(
                            this.props.point.updated_at &&
                            <Timestamp time={this.props.point.updated_at} format='full'
                                       twentyFourHour />
                        ) || this.props.t('generic.updated_never')}
                        divider={false}
                    />
                </div>
                <Dialog
                    open={this.state.img !== null}
                    onRequestClose={this.onClose}
                    modal={false}
                    contentStyle={styles.modal}
                    autoDetectWindowHeight={true}
                >
                    <img src={this.state.img} alt={"Erreur lors de la génération de l'image"}/>
                </Dialog>
            </Paper>
        );
    }
}

export default withTranslation(PointInfo);



// WEBPACK FOOTER //
// src/components/openexplore/PointInfo/PointInfo.js